import { Component, OnInit } from '@angular/core';
import {
  MatDialogConfig,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from 'src/app/common/services/common.service';
import { ActionPromtService } from 'src/app/common/services/action-promt.service';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CROSS, CASH_REGISTER_URL } from 'src/defaultImages.js';
import { UtilService } from 'src/app/util/util.service';

@Component({
  selector: 'app-open-drawer',
  templateUrl: './open-drawer.component.html',
  styleUrls: ['../update-cash/update-cash.component.css'],
})
export class OpenDrawerComponent implements OnInit {
  images = {
    CROSS: CROSS,
    CASH_REGISTER_URL: CASH_REGISTER_URL
  };
  drawerActions = [
    { id: 'open-cashier', name: 'OPEN CASHIER', img: 'cash-counter.svg' },
    { id: 'cash_in', name: 'Cash In', img: 'cash_in.svg' },
    { id: 'cash_out', name: 'Cash Out', img: 'cash_out.svg' },
    { id: 'drawer_kick', name: 'Drawer Kick', img: 'drawer_kick.svg' },
  ];
  cashData;
  loading: boolean = true;
  translationText;
  retryEnabled: boolean = false;
  private ngUnsubscribe = new Subject();
  constructor(
    public dialogRef: MatDialogRef<any>,
    public dialog: MatDialog,
    private apiService: ApiService,
    private message: MessageService,
    private commonService: CommonService,
    private actionService: ActionPromtService,
    private _eventTracker: EventTrackerService,
    private _router: Router,
    public translateService: TranslateService,
    private _utilService: UtilService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
  }

  ngOnInit() {
    this.translateService.get(['OPEN_CASH_DRAWER']).subscribe((translation) => {
      this.translationText = translation.OPEN_CASH_DRAWER;
      this.drawerActions = [
        {
          id: 'open-cashier',
          name: this.translationText.OPEN_CASHIER,
          img: 'cash-counter.svg',
        },
        {
          id: 'cash_in',
          name: this.translationText.CASH_IN,
          img: 'cash_in.svg',
        },
        {
          id: 'cash_out',
          name: this.translationText.CASH_OUT,
          img: 'cash_out.svg',
        },
        {
          id: 'drawer_kick',
          name: this.translationText.DRAWER_KICK,
          img: 'drawer_kick.svg',
        },
      ];
    });
    this.getAllCashStats();
    this.commonService.edit$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((message) => {
        if (message.data == 'refresh' && message.success == 1) {
          this.cancel_clicked();
        }
      });
  }
  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  cardClicked(item) {
    let type;
    if (item.id === 'cash_in') {
      type = 'cash-in';
      this.openCashinCashOut(type);
      this._eventTracker.easyeat_track_event('CASH_IN_CLICKED', {
        'SOURCE TAB': this._router.url.includes('orders')
          ? 'ORDER DASHBOARD'
          : 'CASH BALANCE',
      });
    } else if (item.id === 'cash_out') {
      type = 'cash-out';
      this.openCashinCashOut(type);
      this._eventTracker.easyeat_track_event('CASH_OUT_CLICKED', {
        'SOURCE TAB': this._router.url.includes('orders')
          ? 'ORDER DASHBOARD'
          : 'CASH BALANCE',
      });
    } else if (item.id === 'drawer_kick') {
      type = 'drawer_kick';
      //  this.util.openCashDrawer();
      this.openDrawerKick();
      this._eventTracker.easyeat_track_event('DRAWER_KICK_CLICKED', {
        'SOURCE TAB': this._router.url.includes('orders')
          ? 'ORDER DASHBOARD'
          : 'CASH BALANCE',
      });
    } else if (item.id === 'close-cashier' || item.id === 'open-cashier') {
      type = item.id;
      this.openCashierModal(type);
      this._eventTracker.easyeat_track_event(
        item.id === 'open-cashier'
          ? 'OPEN_CASHIER_CLICKED'
          : 'CLOSE_CASHIER_CLICKED',
        {
          'SOURCE TAB': this._router.url.includes('orders')
            ? 'ORDER DASHBOARD'
            : 'CASH BALANCE',
        }
      );
    }
  }
  getAllCashStats() {
    this.loading = true;
    const restId = localStorage.getItem('restaurant_id');
    const deviceId =  this._utilService.getDeviceUID();

    this.apiService.getCashRegisterAnalytics(restId, deviceId).subscribe(
      (response) => {
        if (response.statusCode == 200) {
          this.cashData = response.data;
          if (this.cashData['active-epoch']) {
            this.drawerActions[0].id = 'close-cashier';
            this.drawerActions[0].name = this.translationText.CLOSE_CASHIER;
          } else {
            this.drawerActions[0].id = 'open-cashier';
            this.drawerActions[0].name = this.translationText.OPEN_CASHIER;
          }
          this.loading = false;
          this.retryEnabled = false;
        }
      },
      (error) => {
        this.message.showError(((error || {}).error || {}).message);
        this.loading = false;
        this.retryEnabled = true;
      }
    );
  }
  async openCashinCashOut(type) {
    let permission =
      type == 'cash-in'
        ? 'CAN_CASH_IN'
        : type == 'cash-out'
        ? 'CAN_CASH_OUT'
        : '';
    this.actionService.openModal(
      permission,
      async (result) => {
        if (result.status == 1 && result.message == 'AUTHORIZED') {
          localStorage.setItem('temp_access_token', result.data);

          if (this.cashData['active-epoch'] != null) {
            const { UpdateCashComponent } = await import(
              /* webpackPrefetch: true */
              '../update-cash/update-cash.component'
            );
            const dialogConfig = new MatDialogConfig();
            dialogConfig.autoFocus = true;
            const dialogRef = this.dialog.open(UpdateCashComponent, {
              backdropClass: 'backdrop',
              maxHeight: '90vh',
              data: {
                type: type,
                restaurant_id: localStorage.getItem('restaurant_id'),
              },
              maxWidth: '100vw',
            });

            dialogRef.afterClosed().subscribe((result: any) => {
              if (result.data == 'success') this.cancel_clicked();
            });
          } else{
            let format_type = type === 'cash-in' ? 'CASH_IN' : (type === 'cash-out' ? 'CASH_OUT' : type);
            this.message.showError(
              this.translationText.CASHIER_IS_CLOSED_TO +
                // ` ${type}, ` +
                ` ${this.translationText[format_type] || type} ` +
                this.translationText.OPEN_CASHIER_FIRST
            );
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
  async openDrawerKick() {
    let permission = 'CAN_DRAWER_KICK';
    this.actionService.openModal(permission, async (result) => {
      if (result.status == 1 && result.message == 'AUTHORIZED') {
        const { DrawerKickComponent } = await import(
          /* webpackPrefetch: true */
          '../drawer-kick/drawer-kick.component'
        );
        localStorage.setItem('temp_access_token', result.data);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        const dialogRef = this.dialog.open(DrawerKickComponent, {
          backdropClass: 'backdrop',
          maxHeight: '90vh',
          maxWidth: '100vw',
        });

        dialogRef.afterClosed().subscribe((result: any) => {
          if ((result || {}).data == 'success') this.cancel_clicked();
        });
      }
    });
  }
  async openCashierModal(type) {
    let permission =
      type == 'close-cashier'
        ? 'CAN_CLOSE_CASHIER'
        : type == 'open-cashier'
        ? 'CAN_OPEN_CASHIER'
        : '';

    this.actionService.openModal(
      permission,
      async (result) => {
        if (result.status == 1 && result.message == 'AUTHORIZED') {
          const { CashierConfirmationComponent } = await import(
            /* webpackPrefetch: true */
            '../cashier-confirmation/cashier-confirmation.component'
          );
          localStorage.setItem('temp_access_token', result.data);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.autoFocus = true;
          const dialogRef = this.dialog.open(CashierConfirmationComponent, {
            backdropClass: 'backdrop',
            maxHeight: '90vh',
            data: {
              type: type,
              restaurant_id: localStorage.getItem('restaurant_id'),
            },
            maxWidth: '100vw',
          });

          dialogRef.afterClosed().subscribe((result: any) => {});
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  isRetryApplicable(item) {
    return (
      (item.id === 'open-cashier' || item.id === 'close-cashier') &&
      this.retryEnabled
    );
  }
}
